import React from 'react';
import styled from 'styled-components';

const StyledSelect = styled.select`
	color: var(--color-text);
	font-family: var(--font-heading);
	background-color: var(--color-background);
`;

const Select = ({ options, onChange }) => {
	return (
		<StyledSelect
			className="border rounded text-xs md:text-sm py-1 sm:py-2 px-1 sm:px-2"
			onChange={(e) => onChange(e)}
		>
			{options.map((option) => {
				return (
					<option key={option.label} value={option.value}>
						{option.label}
					</option>
				);
			})}
		</StyledSelect>
	);
};

export default Select;
